// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__eI0gQ","information_icon":"heading_information_icon__2pQ5y"};